import { DEFAULT_TOAST_LIFE } from "../../../../common/EzToast";
import { affiliateServices } from "../../../../services";
import {
  FETCH_AFFILIATE_REPORT_INIT,
  FETCH_AFFILIATE_REPORT_LIST,
  EXPORT_AFFILIATE_REPORT,
  DOWNLOAD_AFFILIATE_REPORT,
  EMAIL_AFFILIATE_REPORT,
  FETCH_AFFILIATE_LOCATION_DD,
  FETCH_AFFILIATE_NETWORK_DD,
  CLEAR_AFFILIATE_EMAIL_DROPDOWNS,
  TOAST,
  SET_AFFILIATE_REPORT_FILTERS,
  CLEAR_AFFILIATE_REPORT_FILTERS,
  SET_AFFILIATE_REPORT_TABLE_COLUMN_FILTERS,
  CLEAR_AFFILIATE_REPORT_TABLE_COLUMN_FILTERS,
  SAVE_AFFILIATE_REPORT_TABLE_STATE,
  FETCH_AFFILIATE_DEPENDENT_LOCATIONS_DD,
  FETCH_AFFILIATE_DEPENDENT_NETWORKS_DD,
  CLEAR_AFFILIATE_DEPENDENT_DROPDOWNS,
} from "../../../types/affiliateReport.type";

export const initializeAffiliateReportScreen = () => ({
  type: FETCH_AFFILIATE_REPORT_INIT,
});

export const affiliateReportFetchStart = (payload) => ({
  type: FETCH_AFFILIATE_REPORT_LIST.START,
  payload,
});

export const affiliateReportFetchSuccess = (payload) => ({
  type: FETCH_AFFILIATE_REPORT_LIST.SUCCESS,
  payload,
});

export const affiliateReportFetchError = (payload) => ({
  type: FETCH_AFFILIATE_REPORT_LIST.ERROR,
  payload,
});

export const fetchAffiliateReport = (payload) => {
  return (dispatch) => {
    dispatch(affiliateReportFetchStart(payload));
    affiliateServices.fetchAffiliateReport(payload).then((data) => {
      if (!data.isError) {
        dispatch(affiliateReportFetchSuccess(data));
      } else {
        dispatch(affiliateReportFetchError(data));
      }
    });
  };
};

export const exportAffiliateReportStart = (payload) => ({
  type: EXPORT_AFFILIATE_REPORT.START,
  payload,
});

export const exportAffiliateReportSuccess = (payload) => ({
  type: EXPORT_AFFILIATE_REPORT.SUCCESS,
  payload,
});

export const exportAffiliateReportError = (payload) => ({
  type: EXPORT_AFFILIATE_REPORT.ERROR,
  payload,
});

export const resetToast = (payload) => ({
  type: TOAST.RESET,
  payload,
});

export const exportAffiliateReport = (payload) => {
  return (dispatch) => {
    dispatch(exportAffiliateReportStart());
    affiliateServices.exportAffiliateReport(payload).then((data) => {
      if (!data.isError) {
        dispatch(exportAffiliateReportSuccess(data));
      } else {
        dispatch(exportAffiliateReportError(data));
      }
      setTimeout(() => {
        dispatch(resetToast());
      }, DEFAULT_TOAST_LIFE + 1000);
    });
  };
};

export const setAffiliateReportFilters = (payload) => ({
  type: SET_AFFILIATE_REPORT_FILTERS,
  payload,
});

export const clearAffiliateReportFilters = () => ({
  type: CLEAR_AFFILIATE_REPORT_FILTERS,
});

export const setAffiliateReportTableColumnFilters = (payload) => ({
  type: SET_AFFILIATE_REPORT_TABLE_COLUMN_FILTERS,
  payload,
});

export const clearAffiliateReportTableColumnFilters = () => ({
  type: CLEAR_AFFILIATE_REPORT_TABLE_COLUMN_FILTERS,
});

export const saveAffiliateReportTableState = (payload) => ({
  type: SAVE_AFFILIATE_REPORT_TABLE_STATE,
  payload,
});

export const downloadAffiliateReportStart = () => ({
  type: DOWNLOAD_AFFILIATE_REPORT.START,
});

export const downloadAffiliateReportSuccess = (payload) => ({
  type: DOWNLOAD_AFFILIATE_REPORT.SUCCESS,
  payload,
});

export const downloadAffiliateReportError = (payload) => ({
  type: DOWNLOAD_AFFILIATE_REPORT.ERROR,
  payload,
});

export const downloadAffiliateReport = (payload) => {
  return (dispatch) => {
    dispatch(downloadAffiliateReportStart());
    return affiliateServices.downloadAffiliateReport(payload).then((data) => {
      if (!data.isError) {
        dispatch(downloadAffiliateReportSuccess(data));
        return data;
      } else {
        dispatch(downloadAffiliateReportError(data));
        throw new Error(data.message || "Download failed");
      }
    });
  };
};

export const emailAffiliateReportStart = () => ({
  type: EMAIL_AFFILIATE_REPORT.START,
});

export const emailAffiliateReportSuccess = (payload) => ({
  type: EMAIL_AFFILIATE_REPORT.SUCCESS,
  payload,
});

export const emailAffiliateReportError = (payload) => ({
  type: EMAIL_AFFILIATE_REPORT.ERROR,
  payload,
});

export const emailAffiliateReport = (payload) => {
  return (dispatch) => {
    dispatch(emailAffiliateReportStart());
    return affiliateServices.emailAffiliateReport(payload).then((data) => {
      if (!data.isError) {
        dispatch(emailAffiliateReportSuccess(data));
        return data;
      } else {
        dispatch(emailAffiliateReportError(data));
        throw new Error(data.message || "Email failed");
      }
    });
  };
};

// Affiliate Location Dropdown Actions
export const fetchAffiliateLocationDDStart = () => ({
  type: FETCH_AFFILIATE_LOCATION_DD.START,
});

export const fetchAffiliateLocationDDSuccess = (payload) => ({
  type: FETCH_AFFILIATE_LOCATION_DD.SUCCESS,
  payload,
});

export const fetchAffiliateLocationDDError = (payload) => ({
  type: FETCH_AFFILIATE_LOCATION_DD.ERROR,
  payload,
});

export const fetchAffiliateLocationDD = (affiliateId) => {
  return (dispatch) => {
    dispatch(fetchAffiliateLocationDDStart());
    return affiliateServices.fetchAffiliateLocationDropdown(affiliateId).then((data) => {
      if (!data.isError) {
        dispatch(fetchAffiliateLocationDDSuccess(data));
        return data;
      } else {
        dispatch(fetchAffiliateLocationDDError(data));
      }
    });
  };
};

// Affiliate Network Dropdown Actions
export const fetchAffiliateNetworkDDStart = () => ({
  type: FETCH_AFFILIATE_NETWORK_DD.START,
});

export const fetchAffiliateNetworkDDSuccess = (payload) => ({
  type: FETCH_AFFILIATE_NETWORK_DD.SUCCESS,
  payload,
});

export const fetchAffiliateNetworkDDError = (payload) => ({
  type: FETCH_AFFILIATE_NETWORK_DD.ERROR,
  payload,
});

export const fetchAffiliateNetworkDD = (affiliateId) => {
  return (dispatch) => {
    dispatch(fetchAffiliateNetworkDDStart());
    return affiliateServices.fetchAffiliateNetworkDropdown(affiliateId).then((data) => {
      if (!data.isError) {
        dispatch(fetchAffiliateNetworkDDSuccess(data));
        return data;
      } else {
        dispatch(fetchAffiliateNetworkDDError(data));
      }
    });
  };
};

export const clearAffiliateEmailDropdowns = () => ({
  type: CLEAR_AFFILIATE_EMAIL_DROPDOWNS,
});

// Affiliate Dependent Locations Dropdown Actions
export const fetchAffiliateDependentLocationsDDStart = () => ({
  type: FETCH_AFFILIATE_DEPENDENT_LOCATIONS_DD.START,
});

export const fetchAffiliateDependentLocationsDDSuccess = (payload) => ({
  type: FETCH_AFFILIATE_DEPENDENT_LOCATIONS_DD.SUCCESS,
  payload,
});

export const fetchAffiliateDependentLocationsDDError = (payload) => ({
  type: FETCH_AFFILIATE_DEPENDENT_LOCATIONS_DD.ERROR,
  payload,
});

export const fetchAffiliateDependentLocationsDD = (affiliateIds) => {
  return (dispatch) => {
    dispatch(fetchAffiliateDependentLocationsDDStart());
    return affiliateServices.fetchAffiliateDependentLocationsDropdown(affiliateIds).then((data) => {
      if (!data.isError) {
        dispatch(fetchAffiliateDependentLocationsDDSuccess(data));
        return data;
      } else {
        dispatch(fetchAffiliateDependentLocationsDDError(data));
      }
    });
  };
};

// Affiliate Dependent Networks Dropdown Actions
export const fetchAffiliateDependentNetworksDDStart = () => ({
  type: FETCH_AFFILIATE_DEPENDENT_NETWORKS_DD.START,
});

export const fetchAffiliateDependentNetworksDDSuccess = (payload) => ({
  type: FETCH_AFFILIATE_DEPENDENT_NETWORKS_DD.SUCCESS,
  payload,
});

export const fetchAffiliateDependentNetworksDDError = (payload) => ({
  type: FETCH_AFFILIATE_DEPENDENT_NETWORKS_DD.ERROR,
  payload,
});

export const fetchAffiliateDependentNetworksDD = (affiliateIds) => {
  return (dispatch) => {
    dispatch(fetchAffiliateDependentNetworksDDStart());
    return affiliateServices.fetchAffiliateDependentNetworksDropdown(affiliateIds).then((data) => {
      if (!data.isError) {
        dispatch(fetchAffiliateDependentNetworksDDSuccess(data));
        return data;
      } else {
        dispatch(fetchAffiliateDependentNetworksDDError(data));
      }
    });
  };
};

export const clearAffiliateDependentDropdowns = () => ({
  type: CLEAR_AFFILIATE_DEPENDENT_DROPDOWNS,
});
